module.exports = __webpack_public_path__ + "static/media/default_response.e9e72aeb.png";